import React from 'react';
import { Link } from 'react-router-dom';

/**
 * The way back to the Clients list: a quiet ghost link at the start of the header's action
 * group, just before Compose. A real
 * anchor (not a button that calls navigate), so it can be opened in a new tab and read
 * as a link. The arrow nudges left on hover, except for people who ask for less motion.
 */
export default function BackLink() {
  return (
    <Link
      to="/hub/clients"
      data-testid="back-to-clients"
      className="group inline-flex h-10 items-center gap-1.5 rounded px-1 text-sm font-medium text-gray-500 hover:text-gray-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand dark:text-gray-400 dark:hover:text-gray-100"
    >
      <svg
        className="h-4 w-4 transition-transform group-hover:-translate-x-0.5 motion-reduce:transition-none motion-reduce:group-hover:translate-x-0"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
      >
        <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
      </svg>
      All clients
    </Link>
  );
}
